module.exports = __webpack_public_path__ + "media/images/vector/YoutubeLogo-7d65f21f498b5e1a1982477eb079bd55.svg";